/** A friendly cartoon ghost centred on (x, y). */
export function drawGhost(c: CanvasRenderingContext2D, x: number, y: number, r: number) {
  c.fillStyle = '#f4f6f8';
  c.beginPath();
  c.arc(x, y - r * 0.2, r, Math.PI, 0);
  c.lineTo(x + r, y + r * 0.8);
  for (let i = 0; i < 4; i++) {
    const x0 = x + r - (i * r) / 2;
    c.quadraticCurveTo(x0 - r / 4, y + r * 0.45, x0 - r / 2, y + r * 0.8);
  }
  c.closePath();
  c.fill();
  c.fillStyle = '#1d1d2b';
  c.beginPath();
  c.ellipse(x - r * 0.35, y - r * 0.25, r * 0.13, r * 0.2, 0, 0, Math.PI * 2);
  c.ellipse(x + r * 0.35, y - r * 0.25, r * 0.13, r * 0.2, 0, 0, Math.PI * 2);
  c.fill();
  c.beginPath();
  c.ellipse(x, y + r * 0.15, r * 0.14, r * 0.18, 0, 0, Math.PI * 2);
  c.fill();
}

/** A ghost as a canvas, for Phaser textures and thumbnails. */
export function ghostCanvas(size: number): HTMLCanvasElement {
  const el = document.createElement('canvas');
  el.width = size;
  el.height = size;
  drawGhost(el.getContext('2d')!, size / 2, size / 2, size * 0.38);
  return el;
}
